import React from 'react';
import { ProjectContext } from './ProjectContext';

const withProjectContext = Component => ({ returnPath, ...rest }) => (
  <ProjectContext.Consumer>
    {({ returnPath }) => (
      <Component
        returnPath={returnPath}
        {...rest}
      />
    )}
  </ProjectContext.Consumer>
);

export default withProjectContext;



// WEBPACK FOOTER //
// ./src/components/projects/withProjectContext.js